import { producaov2 as api } from "./apis";

export const systemLogs = (local, texto) => {
  const acao = JSON.stringify({
    local,
    texto,
  });

  return api
    .post("system_logs", { acao })
    .catch((err) => console.error("Erro no registro de logs do admin::", err));
};
